(function(angular) {
    "use strict";
    var channels, selectedChannelId, privateCallChannelId = -1, privateCallChannels;

    var spc = {
        id: 0,
        name: 'System Presence Channel',
        active: true
    };

    var ChannelData = function(wtcpjsChannel, isActive) {
        return {
            id: wtcpjsChannel.channelId,
            name: wtcpjsChannel.channelName,

            active: isActive,
            ready: false,
            canTransmitAudio: false,
            canReceiveAudio: false,
            isSimplex: false,
            numEndpoints: 0,
            isRxOnlyChannel: false,
            update(name, canTransmitAudio, canReceiveAudio, isSimplex) {
                this.name = name;
                this.canTransmitAudio = canTransmitAudio;
                this.canReceiveAudio = canReceiveAudio;
                this.isRxOnlyChannel = !canTransmitAudio && canReceiveAudio; 
                this.isSimplex = isSimplex;
            }
        };
    };

    class PrivateCallChannelData extends ChannelData {
        constructor(wtcpjsChannel, isActive) {
            super(wtcpjsChannel, isActive);
            this.callType = 0; // 1: Endpoint call, 2: E164 Number
            this.callActive = false;
            this.calleeNumber = "";
            this.calleeName = "";
            this.callId = 0;
            this.participantId = "";
        }
    }

    class ChannelModel {
        constructor($rootScope, $q, $log, settingsService) {
            this.$q = $q;
            this.$rootScope = $rootScope;
            this.$log = $log;
            this.ChannelData = ChannelData;
            this.PrivateCallChannelData = PrivateCallChannelData;

            this.settingsSvc = settingsService;
            channels = {};
            privateCallChannels = {};
            selectedChannelId = 0;
        }
        addOrUpdateChannel(channel) {
            let chan = channels[channel.id];
            if (!chan) {
                // Check if user ever updated talk group settings, if so use those. Otherwise default active flag to true
                let channelSelections = this.settingsSvc.getChannelSelection();
                let isActive = (typeof channel.active != 'undefined') ?
                    channel.active :
                    channelSelections[channel.channelId] && !channelSelections[channel.channelId].active ? false : true;
                chan = new ChannelData(channel, isActive);
            }

            channels[chan.id] = chan;
            this.$rootScope.$broadcast('channelModel.channelsUpdated', channels);
        }
        addEmptyChannel(channelId) {
            this.addOrUpdateChannel({
                channelId: channelId
            }, true); // isActive = true
        }
        addOrUpdatePrivateCallChannel(callType, fromUserName, toUserName, toCallAlias, calleeName, callId, participantId, barge) {
            const key = fromUserName + toUserName;
            let name = calleeName;
            let pcChan = privateCallChannels[key];
            if (!pcChan) {
                pcChan = new PrivateCallChannelData({ channelId: privateCallChannelId--, channelName: name }, true);
                pcChan.callType = callType;
                pcChan.calleeNumber = toCallAlias;
                pcChan.calleeName = calleeName;
                pcChan.participantId = participantId;
                pcChan.bargeCall = barge;
                channels[pcChan.id] = privateCallChannels[key] = pcChan;
                this.$rootScope.$broadcast('channelModel.privateCallChannelAdded', pcChan);
            } 

            pcChan.callId = callId;
            pcChan.active = true;
            
            return pcChan.id;
        }
        addOrUpdateAndSelectPrivateCallChannel(myUser, targetUser) {
            let channel = this.addOrUpdatePrivateCallChannel(2, myUser.userName, targetUser.userName, targetUser.callAlias, targetUser.displayName, null, targetUser.userName);
            this.selectChannel(channel);
        }
        getChannel(channelId) {
            return channelId ? channels[channelId] : spc;
        }
        getChannels() {
            return channels;
        }
        getActiveChannelIds() {
            return Object.keys(channels).filter(id => channels[id].active);
        }
        areAnyChannelsActive() {
            return this.getActiveChannelIds().length > 0;
        }
        selectChannel(channelId) {
            let channel = channels[channelId];

            // If selecting a private call channel make sure its active
            // It might have been closed by the user but they are selecting it from activities
            if(channel.id < 0) {
                channel.active = true;
            }
            // reset endpoint info.
            //Do this in endpointsModel -> endpoints = {};
            selectedChannelId = channelId;

            this.$log.debug("channelModel.selectChannel " + channelId);

            // FIRST we get the components ready by notifying that the channel is being selected
            this.$rootScope.$broadcast('channelModel.channelSelected', channel);
        }
        clearSelectedChannel() {
            selectedChannelId = 0;
        }
        getSelectedChannel() {
            return channels[selectedChannelId];
        }
        selectFirstActiveChannel() {
            let that = this;
            let activeChannelIds = this.getActiveChannelIds();
            if (!activeChannelIds.includes(selectedChannelId)) {
                this.$rootScope.$applyAsync(function ($scope) {
                    that.selectChannel(activeChannelIds[0]);
                });
            }
        }
        areChannelsNewOrChanged(wtcpjsChannels) {
            return wtcpjsChannels.length !== Object.keys(channels).length || !wtcpjsChannels.every((e, i, a) => { return channels.hasOwnProperty(e.channelId); });
        }

        reconnectedWithReducedActiveChannels(wtcpjsChannels) {
            return this.getActiveChannelIds().length > 0 && wtcpjsChannels.length !== this.getActiveChannelIds().length;
        } 
        removeChannel(channelId) {
            delete channels[channelId];
            this.$log.debug('channelMode.channelRemoved ' + channelId);
            this.$rootScope.$broadcast('channelModel.channelRemoved', channelId);
        }
        resetReadyState(channelIds) {
            for (var x in channelIds) {
                if(channels.hasOwnProperty(channelIds[x])) {
                    channels[channelIds[x]].ready = false;
                }
            }
        }
        clearPrivateCallChannels() {
            privateCallChannels = {};

            this.$rootScope.$broadcast('channelModel.privateCallChannelsCleared');
        }
        clearChannels() {
            // When clearing channels, the intent is to only clear public talkgroup channels
            // If there are any private call channels lets make sure to copy them back in
            channels = {};
            Object.getOwnPropertyNames(privateCallChannels).forEach((key) => {
                channels[privateCallChannels[key].id] = privateCallChannels[key];
            });

            selectedChannelId = null;
            this.$rootScope.$broadcast('channelModel.channelsCleared');
        }
    }

    angular
        .module('webcomm')
        .service('channelModel', ['$rootScope', '$q', '$log', 'settingsService', ChannelModel]);
})(angular);
